export default __webpack_public_path__ + "static/media/video-1.e54614af.mp4";